(function () {
  if (window.__jotformEmbedInit) return;
  window.__jotformEmbedInit = true;

  const HANDLER_SRC = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
  let handlerScript = null;

  function ensureHandlerScript(onReady) {
    if (window.jotformEmbedHandler) {
      onReady();
      return;
    }
    if (!handlerScript) {
      handlerScript = document.querySelector('script[src="' + HANDLER_SRC + '"]');
      if (!handlerScript) {
        handlerScript = document.createElement('script');
        handlerScript.src = HANDLER_SRC;
        handlerScript.defer = true;
        document.body.appendChild(handlerScript);
      }
    }
    handlerScript.addEventListener('load', onReady, { once: true });
  }

  function initFrame(container) {
    if (container.hasAttribute('data-embed-initialized')) return;
    const iframe = container.querySelector('iframe');
    if (!iframe || !iframe.id) return;
    container.setAttribute('data-embed-initialized', 'true');

    ensureHandlerScript(function () {
      window.jotformEmbedHandler('iframe#' + iframe.id, 'https://form.jotform.com/');
    });
  }

  function init() {
    // Elements inside an Alpine `<template x-teleport>` (used by the
    // price-match/enquire modals) aren't part of the live DOM until Alpine
    // clones them into <body> on init, which happens before this runs
    // (alpine.min.js runs before DOMContentLoaded).
    document.querySelectorAll('.jotform-embed__frame[data-jotform-id]').forEach(initFrame);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
